import $ from 'jquery'
import { Popover } from './popover'

const Status = {
  URL: 'https://status.postmarkapp.com/api/1.0/',
  INCIDENT_URL: 'https://status.postmarkapp.com/incidents/',
  HOOK_ROOT: '.js-status',
  CONTENT: {
    UP: ['Up and running 👍', 'We’re a-okay! 👌', 'We’re up'],
    MAINTENANCE: 'Maintenance',
    DELAY: 'Delays',
    DEGRADED: 'Performance issues',
    DOWN: 'Down',
  },

  /**
   * Initializes this module
   */
  init: function () {
    // Track initial state
    Status.initialState = $(Status.HOOK_ROOT).html()
    Status.initialClass = $(Status.HOOK_ROOT).attr('class')

    // Fetch current status when help button is clicked
    $(document).on('click', '.js-help', Status.fetch)

    // Reset state when the help dropdown is closed
    $(Popover.HOOK_ROOT).on('popover.close', Status.close)
  },

  /**
   * Fetches the current status
   */
  fetch: function () {
    $.ajax({
      url: Status.URL + 'status',
      cache: false,
      beforeSend: function () {
        // Reset default CSRF headers
      },
    }).done(function (response) {
      // Update DOM if we're up
      // Otherwise fetch the latest incident
      response.status === 'UP'
        ? Status.update(response)
        : Status.fetchIncident(response)
    })
  },

  /**
   * Fetches the incident details if there's an issue
   * @param  {object} status Response from the initial status request
   */
  fetchIncident: function (status) {
    $.ajax({
      url: Status.URL + 'last_incident',
      cache: false,
      beforeSend: function () {
        // Reset default CSRF headers
      },
    }).done(function (incident) {
      Status.update(status, incident)
    })
  },

  /**
   * Updates the help dropdown once we have data
   * @param  {Object} status   Response from the initial status request
   * @param  {Object} incident (optional) Response from the incident request
   */
  update: function (status, incident) {
    const content = Status.CONTENT[status.status]

    // Selectors
    const $title = $(Status.HOOK_ROOT).find('.c-help-menu_title')
    const $desc = $(Status.HOOK_ROOT).find('.c-help-menu_desc')

    // Update icon
    $(Status.HOOK_ROOT)
      .find('.c-help-menu_icon')
      .removeClass('c-help-menu_icon--status')
      .addClass('c-help-menu_icon--status-' + status.status.toLowerCase())

    // Add modifier class
    $(Status.HOOK_ROOT).addClass(
      'c-help-menu_item--' + status.status.toLowerCase()
    )

    // Check whether there's an incident
    if (incident) {
      // Update title
      $title.text('Status: ' + content)

      // Update labels
      $desc.text(incident.title)

      // Update link URL
      $(Status.HOOK_ROOT)
        .find('.c-help-menu_link')
        .attr('href', Status.INCIDENT_URL + incident.id)
    } else {
      // Use a random label if we're up
      // $title.text('Status: We’re up');
      $title.text(
        'Status: ' + content[Math.floor(Math.random() * content.length)]
      )
      $desc.hide()
    }
  },

  /**
   * Resets the state when the popover closes
   * @param  {Object} event
   */
  close: function (event) {
    if ($(event.target).data('popover') === '#help-popover') {
      // Reset the state when the animation is finished
      setTimeout(function () {
        $(Status.HOOK_ROOT)
          .html(Status.initialState)
          .attr('class', Status.initialClass)
      }, 500)
    }
  },
}

$(Status.init)
